<template>
  <div v-if="withLayout && empresa != null" class="layout-wrapper">
    <AppTopBar />

    <div class="layout-main md:px-3 pb-5">
      <div class="ajuste-altura">
        <router-view />
      </div>
    </div>

    <AppFooter />
  </div>
  <div v-else><router-view /></div>
  <a id="whatsapp_suporte" v-if="wp_link != ''" :href="wp_link" target="_blank" v-tooltip="'Falar com um Vendedor'">
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="none" viewBox="0 0 48 48" id="whatsapp">
      <rect width="48" height="48" fill="#0DC143" rx="24"></rect>
      <path fill="#fff"
        d="M34.7507 13.2115C32.1777 10.5628 28.621 9.125 24.9885 9.125C17.2696 9.125 11.0642 15.4061 11.1399 23.0493C11.1399 25.4709 11.821 27.8169 12.9561 29.9358L10.9885 37.125L18.3291 35.2331C20.3723 36.3682 22.6426 36.898 24.9128 36.898C32.5561 36.898 38.7615 30.6169 38.7615 22.9736C38.7615 19.2655 37.3237 15.7845 34.7507 13.2115ZM24.9885 34.552C22.9453 34.552 20.902 34.0223 19.1615 32.9628L18.7074 32.7358L14.3183 33.8709L15.4534 29.5574L15.1507 29.1034C11.821 23.7304 13.4101 16.6169 18.8588 13.2872C24.3074 9.95743 31.3453 11.5466 34.675 16.9953C38.0047 22.4439 36.4156 29.4818 30.9669 32.8115C29.2264 33.9466 27.1074 34.552 24.9885 34.552ZM31.648 26.152L30.8156 25.7736C30.8156 25.7736 29.6047 25.2439 28.848 24.8655C28.7723 24.8655 28.6966 24.7899 28.621 24.7899C28.3939 24.7899 28.2426 24.8655 28.0912 24.9412C28.0912 24.9412 28.0156 25.0169 26.9561 26.2277C26.8804 26.3791 26.7291 26.4547 26.5777 26.4547H26.502C26.4264 26.4547 26.275 26.3791 26.1993 26.3034L25.821 26.152C24.9885 25.7736 24.2318 25.3196 23.6264 24.7142C23.475 24.5628 23.248 24.4115 23.0966 24.2601C22.5669 23.7304 22.0372 23.125 21.6588 22.4439L21.5831 22.2926C21.5074 22.2169 21.5074 22.1412 21.4318 21.9899C21.4318 21.8385 21.4318 21.6872 21.5074 21.6115C21.5074 21.6115 21.8101 21.2331 22.0372 21.0061C22.1885 20.8547 22.2642 20.6277 22.4156 20.4764C22.5669 20.2493 22.6426 19.9466 22.5669 19.7196C22.4912 19.3412 21.5831 17.298 21.3561 16.8439C21.2047 16.6169 21.0534 16.5412 20.8264 16.4655H20.5993C20.448 16.4655 20.221 16.4655 19.9939 16.4655C19.8426 16.4655 19.6912 16.5412 19.5399 16.5412L19.4642 16.6169C19.3128 16.6926 19.1615 16.8439 19.0101 16.9196C18.8588 17.0709 18.7831 17.2223 18.6318 17.3736C18.102 18.0547 17.7993 18.8872 17.7993 19.7196C17.7993 20.325 17.9507 20.9304 18.1777 21.4601L18.2534 21.6872C18.9345 23.125 19.8426 24.4115 21.0534 25.5466L21.3561 25.8493C21.5831 26.0764 21.8101 26.2277 21.9615 26.4547C23.5507 27.8169 25.3669 28.8007 27.4101 29.3304C27.6372 29.4061 27.9399 29.4061 28.1669 29.4818C28.3939 29.4818 28.6966 29.4818 28.9237 29.4818C29.302 29.4818 29.7561 29.3304 30.0588 29.1791C30.2858 29.0277 30.4372 29.0277 30.5885 28.8764L30.7399 28.725C30.8912 28.5736 31.0426 28.498 31.1939 28.3466C31.3453 28.1953 31.4966 28.0439 31.5723 27.8926C31.7237 27.5899 31.7993 27.2115 31.875 26.8331C31.875 26.6818 31.875 26.4547 31.875 26.3034C31.875 26.3034 31.7993 26.2277 31.648 26.152Z">
      </path>
    </svg>
  </a>
  <Toast position="top-right" />
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import AppTopBar from "./componentes/AppTopbar.vue";
import AppFooter from "./componentes/AppFooter.vue";

import Cookie from "js-cookie";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, onValue, off } from "firebase/database";

import { createGtm } from '@gtm-support/vue-gtm';

import "./assets/layout/App.scss";

var onValueCarrinho = null;

export default {
  data() {
    return {
      withLayout: true,
      corApp: "",

      logoDefault: require("@/assets/imagens/logo-npc.png"),
      logo: null,
      user: null,
      userWhatsapp: "",
      vendedor: null,
      empresa: null,
      carrinho: null,
      carrinhoQtd: 0,
      pedidosQtd: 0,
      valorSelecionado: "",
      wp_link: "",

      conteudo: [],

    };
  },
  async created() {

    const auth = getAuth();
    const database = getDatabase();

    this.logo = this.logoDefault;

    let parametros = window.location.pathname
      .substring(1)
      .split("/")
      .filter(function (el) {
        return el;
      });

    let limpaURL = parametros.length > 0;

    const paramsUser = Cookie.get("params-id");

    if (parametros.length == 0 && typeof paramsUser != "undefined") {
      parametros = paramsUser.split(",");
    }

    let res = await this.$apiv3
      .post("/ecommerce/sessao", {
        dominio: window.location.hostname,
        "parametros": parametros,
      });

    if (res.data.success) {

      Cookie.set("params-id", parametros, {
        secure: window.location.hostname != "localhost",
        expires: 365,
      });

      this.empresa = res.data.data.empresa;
      this.vendedor = res.data.data.vendedor;
      this.valorSelecionado = res.data.data.valorSelecionado;

      if (res.data.data.valorSelecionado == "valorAtacado") {
        this.$root.empresa.configuracoes.ECOMMERCE_VALORES_ATACADO_VISIVEL = true;
        this.$root.empresa.configuracoes.ECOMMERCE_VALORES_VAREJO_VISIVEL = false;
      }
      else if (res.data.data.valorSelecionado == "valorVarejo") {
        this.$root.empresa.configuracoes.ECOMMERCE_VALORES_ATACADO_VISIVEL = false;
        this.$root.empresa.configuracoes.ECOMMERCE_VALORES_VAREJO_VISIVEL = true;
      }

      this.$apiv3.setIdEmpresa(this.empresa.id);

      //////////////////////

      const foneEmpresa = this.$utils.validString(this.empresa.foneEmpresa).replace(/[^0-9]/g, "");
      if (this.$utils.validString(this.empresa.configuracoes.ECOMMERCE_IDENTIFICACAO_WHATSAPP) != '') {
        this.wp_link = this.empresa.configuracoes.ECOMMERCE_IDENTIFICACAO_WHATSAPP;
      } else if (foneEmpresa != "") {
        this.wp_link = "https://wa.me/55" + foneEmpresa;
      }

      //////////////////////

      onAuthStateChanged(auth, async (user) => {

        this.user = null;

        if (user) {

          try {

            const data = (await this.$apiv3.get("/ecommerce/usuario")).data;

            if (data.success) {

              this.user = data.data;

            } else {

              await auth.signOut();

              location.reload(true);

            }

          } catch {

            await auth.signOut();

            location.reload(true);

          }

        }

        if (this.carrinho == null) {
          this.atualizaCarrinhoEmTempoReal();
        }

      });

      ////////////////////////

      // #region PARAMETROS PERSONALIZADOS //

      if (parametros.length >= 2) {
        if (parametros.indexOf("pagamento") != -1) {
          let idOrcamento;
          if (parametros[0] == "pagamento") {
            idOrcamento = parametros[1];
          } else if (parametros[1] == "pagamento") {
            idOrcamento = parametros[2];
          }

          this.$router.push("/pagamento/" + idOrcamento);
          history.pushState(
            "",
            document.title,
            "/#/pagamento/" + idOrcamento
          );

          limpaURL = false;
        }
      }

      // #endregion PARAMETROS PERSONALIZADOS //

      if (limpaURL) {
        history.pushState("", document.title, "/#/");
      }

      // #region GTM //

      if (typeof this.empresa.gtm == "string" && this.empresa.gtm != "") {

        this.$.appContext.app.use(
          createGtm({
            id: this.empresa.gtm, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
            enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
            debug: false, // Whether or not display console logs debugs (optional)
            loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
            vueRouter: this.$router, // Pass the router instance to automatically sync with router (optional)
            // trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
          }),
        );

      }

      // #endregion GTM //

      // #region Inicializa Pixel //

      if (typeof this.empresa.idPexel == "string" && this.empresa.idPexel != "") {

        const facebookPixelSnippet = function (f, b, e, v, callback) {
          let n, t, s;
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod
              ? n.callMethod.apply(n, arguments)
              : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = "2.0";
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
          t.onload = callback;
        };

        facebookPixelSnippet(
          window,
          document,
          "script",
          "https://connect.facebook.net/en_US/fbevents.js",
          () => {
            this.$fbq = fbq;
            fbq(
              "init",
              typeof this.empresa.idPexel != "undefined"
                ? this.empresa.idPexel
                : "240300791604613"
            );
            fbq("track", "ViewContent");
          }
        );

      }

      // #endregion Inicializa Pixel //

    } else {
      window.location.href = "/#/erro";
    }

    const versaoRef = ref(database, "GrerenciarVesao/ecommerce");
    onValue(versaoRef, (snapshot) => {
      if (snapshot.exists()) {
        if (
          window.location.hostname != "localhost" &&
          snapshot.val() != this.$version
        )
          location.reload(true);
      }
    });

  },
  mounted() {
    if (this.$utils.isMobileOrTablet()) document.body.classList.add("is-touch");

    if (/iPhone/i.test(navigator.userAgent)) {
      document.body.classList.add("is-iphone");
    }
  },
  watch: {
    $route() {
      this.withLayout = !this.$route.matched.some(
        (record) => record.meta.freeLayout
      );
      this.$toast.removeAllGroups();
    },

    empresa: function (empresa) {

      this.logo = this.logoDefault;

      if (empresa != null) {
        this.corApp = empresa.configuracoes.ECOMMERCE_LAYOUT_COR;
        document.title = empresa.nomeEmpresa + ' - E-Commerce';

        if (typeof empresa.foto == "string" && empresa.foto != "") {
          this.logo = empresa.foto;
        }

      } else {
        this.corApp = "";
        document.title = 'E-Commerce';
      }

    },

    corApp: function (cor) {
      if (cor) {
        document.body.style =
          "--primaryBackgroundColor: #" + cor + "; --secondaryColor: #" + cor;
      } else {
        document.body.style = "";
      }
    },
  },
  methods: {
    isDesktop() {
      return window.innerWidth > 1024;
    },
    async carregaCarrinho() {

      if (this.empresa == null) {
        this.carrinho = null;
        this.carrinhoQtd = 0;
        return;
      }

      const response = await this.$apiv3.get("/carrinhos/" + (this.$root.user != null ? this.$root.user.id : this.$fpid));

      if (response.data.success) {
        if (response.data.data.idEmpresa != this.empresa.id) {
          return
        }
        this.carrinho = response.data.data;
        this.carrinhoQtd = 0;
        for (let p of Object.values(this.carrinho.carrinhoGrade)) {
          for (let c of Object.values(p.cor)) {
            for (let t of Object.values(c.tamanho)) {
              this.carrinhoQtd += t.qnt;
            }
          }
        }

      } else {

        this.carrinho = null;
        this.carrinhoQtd = 0;

      }

    },
    async atualizaCarrinhoEmTempoReal() {

      if (this.empresa == null) {
        return;
      }

      if (typeof this.empresa.configuracoes.ECOMMERCE_CARRINHO_EXPIRACAO != "number" || this.empresa.configuracoes.ECOMMERCE_CARRINHO_EXPIRACAO == 0)
        return;

      let userId;
      if (this.user == null) {
        while (this.$fpid == null) {
          console.log(this.$fpid)
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        userId = this.$fpid;
      } else {
        userId = this.user.id;
      }

      if (onValueCarrinho != null)
        off(onValueCarrinho);

      onValueCarrinho = ref(getDatabase(), "FINALIZACAOV3/monitoramentoCarrinho/" + this.empresa.id + "/" + userId + "/tempo");
      onValue(onValueCarrinho, (snapshot) => {

        // console.log("Monitoramento: " + snapshot.val());

        this.carregaCarrinho();
        this.carregaPedidos();

        if (snapshot.exists()) {

          this.$toast.add({
            severity: "info",
            summary: "Seu carrinho espira em " + snapshot.val() + " minutos",
            detail: "Finalize seu carrinho antes do tempo acabar",
            life: 6000,
          });

        }

      });

    },
    async carregaConteudo() {

      let res = await this.$apiv3.get("/ecommerce/home-antiga");

      res = res.data;

      if (res.success) {

        let conteudo_final = [];

        let i = 0;
        const limite = 16;
        for (let c of Object.values(res.data)) {

          if (c.componente == "Status") {
            c.id = "sessao" + (i++) + "-status";
            conteudo_final.push(c);
            continue;
          }

          c.nome_interno = this.$utils.getStdObject(c.nome);

          const slug = this.$utils.slugify(c.nome);

          let itens = this.$utils.getStdObject(c.itens);

          if (itens.length <= limite) {
            c.id = "sessao" + (i++) + "-" + slug;
            conteudo_final.push(c);
            continue;
          }

          let continuidade = this.$utils.getStdObject(itens).splice(limite);
          itens = this.$utils.getStdObject(itens).splice(0, limite);

          if (itens.length > 0) {

            c.id = "sessao" + (i++) + "-" + slug;
            c.idPai = c.id;
            c.itens = itens;
            conteudo_final.push(this.$utils.getStdObject(c));

            delete c.nome;

            while (continuidade.length > 0) {

              itens = this.$utils.getStdObject(continuidade).splice(0, limite);
              continuidade = this.$utils.getStdObject(continuidade).splice(limite);

              c.id = "sessao" + (i++) + "-" + slug;
              c.itens = itens;
              conteudo_final.push(this.$utils.getStdObject(c));

            }

          }

        }

        this.conteudo = conteudo_final;

      }

    },
    async carregaPedidos() {

      if (this.empresa == null || this.$root.user == null) {
        this.pedidosQtd = 0;
        return;
      }

      const response = await this.$apiv3.get("/carrinhos?tipo=Orcamento&fields=idEmpresa,numeroPedido&cliente.id=" + (this.$root.user != null ? this.$root.user.id : this.$fpid));

      if (response.data.success) {

        this.pedidosQtd = response.data.data.length;

      } else {

        this.pedidosQtd = 0;

      }

    },
  },
  components: {
    AppTopBar: AppTopBar,
    AppFooter: AppFooter,
  },
};
</script>
